import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { InterfaceValidationSelectionService } from '../interface-validation-selection.service';

@Component({
    selector: 'app-shipment-screen',
    template: ` <rt-trip-error [ormId]="id$ | async"></rt-trip-error>`,
})
export class InterfaceValidationSingleScreenComponent implements OnInit {
    id$: Observable<number>;

    constructor(private selectionService: InterfaceValidationSelectionService) {}

    ngOnInit(): void {
        this.id$ = this.selectionService.selectionState$.pipe(
            map((state) => Number(state.selectedIds[0]) || 0),
        );
    }
}
